import { InjectionToken } from '@angular/core';

export const PERFORMANCE_QUEUE = new InjectionToken<Array<QueuedAppMark>>('PERFORMANCE_QUEUE');
